// src/lib/queryKeys.ts
export const queryKeys = {
  files: {
    list: (wsId: string, sortType?: string, sortOrder?: string, fileTypeFilter?: string, refreshToken?: number) => 
      ['files', 'list', wsId, sortType, sortOrder, fileTypeFilter, refreshToken] as const,
    detail: (wsId: string, fileId: string) => ['files', 'detail', wsId, fileId] as const,
  },
  boards: {
    list: (wsId: string, hashtag?: string, searchQuery?: string, folderId?: string | null) => 
      ['boards', 'list', wsId, hashtag, searchQuery, folderId] as const,
    detail: (wsId: string, boardId: string) => ['boards', 'detail', wsId, boardId] as const,
    meta: (wsId: string, boardId: string) => ['boards', 'meta', wsId, boardId] as const,
  },
  tags: {
    list: (wsId: string) => ['tags', 'list', wsId] as const,
  },
  history: {
    list: (wsId: string, boardId: string) => ['history', 'list', wsId, boardId] as const,
  },
  calendar: {
    data: (wsId: string) => ['calendar', 'data', wsId] as const,
  },
  threads: {
    list: (wsId: string) => ['threads', 'list', wsId] as const,
    detail: (wsId: string, threadId: string) => ['threads', 'detail', wsId, threadId] as const,
    posts: (wsId: string, threadId: string) => ['threads', 'posts', wsId, threadId] as const,
    comments: (wsId: string, threadId: string) => ['threads', 'comments', wsId, threadId] as const,
  },
} as const;
